import { AlertTriangle } from 'lucide-react';
import {
  ConnectResourceValue,
  LegacyConnectResourceValue,
  getDisplayName,
  isLegacyConnectResourceValue
} from '../../../common/connect-resource';
import { Tooltip, TooltipContent, TooltipTrigger } from '@@/ui/primitives';

export type { ConnectResourceValue };

interface ConnectResourceViewerProps {
  value: ConnectResourceValue | LegacyConnectResourceValue;
}

export function ConnectResourceViewer({ value }: ConnectResourceViewerProps) {
  const displayName = getDisplayName(value);
  const isLegacy = isLegacyConnectResourceValue(value);

  return (
    <div className='flex items-center gap-2'>
      <span className='text-neutral-950 text-sm'>{displayName}</span>
      {isLegacy && (
        <Tooltip>
          <TooltipTrigger asChild>
            <AlertTriangle className='size-4 text-red-500' />
          </TooltipTrigger>
          <TooltipContent>
            <p>Legacy format - re-save to update</p>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
